import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {toast} from "react-toastify";
import TextField from "@mui/material/TextField";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {getMahsulotlar, mahsulotSave, mahsulotEdit, messageReset} from "../store/mahsulot";

const CATEGORY_KEYS = [
    {key: 'ishlab_chiqarish', labelKey: 'cat_ishlab_chiqarish'},
    {key: 'xizmat',           labelKey: 'cat_xizmat'},
    {key: 'other',            labelKey: 'cat_other'},
]

function MahsulotAdd(props) {
    const {t}      = useTranslation()
    const navigate = useNavigate()
    const params   = useParams()
    const isEdit   = !!params.id

    const [title,       setTitle]       = useState('')
    const [category,    setCategory]    = useState('ishlab_chiqarish')
    const [description, setDescription] = useState('')
    const [unit,        setUnit]        = useState('')
    const [quantity,    setQuantity]    = useState('')
    const [price,       setPrice]       = useState('')

    useEffect(() => {
        if (isEdit) props.getMahsulotlar(1, 200)
    }, [])

    useEffect(() => {
        if (isEdit && props.mahsulotlar?.length) {
            const item = props.mahsulotlar.find(m => String(m.id) === String(params.id))
            if (item) {
                setTitle(item.title)
                setCategory(item.category || 'ishlab_chiqarish')
                setDescription(item.description || '')
                setUnit(item.unit || '')
                setQuantity(item.quantity || '')
                setPrice(item.price || '')
            }
        }
    }, [props.mahsulotlar])

    useEffect(() => {
        if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'})
            navigate('/mahsulotlar/')
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    function saveFormData(e) {
        e.preventDefault()
        const data = {title, category, description, unit, quantity, price}
        if (isEdit) {
            props.mahsulotEdit({...data, id: params.id})
        } else {
            props.mahsulotSave(data)
        }
    }

    return (
        <div>
            <div className={'page'}>
                <Header/><Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                            {t('back')}
                        </Button>
                        <h2 className={'page-title text-center'}>
                            {isEdit ? t('change_info') : t('mahsulot_add')}
                        </h2>
                        <form className={'add-form add-document'} onSubmit={saveFormData}
                              style={{maxWidth: '600px', margin: '0 auto'}}>
                            <p>
                                <span>{t('mahsulot_nomi')}:</span>
                                <TextField label={t('mahsulot_nomi')} value={title} required
                                           onChange={e => setTitle(e.target.value)}
                                           type="text" variant="outlined"/>
                            </p>
                            <p>
                                <span>{t('mahsulot_turi')}:</span>
                                <FormControl fullWidth>
                                    <InputLabel>{t('mahsulot_turi')}</InputLabel>
                                    <Select value={category} label={t('mahsulot_turi')}
                                            onChange={e => setCategory(e.target.value)}>
                                        {CATEGORY_KEYS.map(c => (
                                            <MenuItem key={c.key} value={c.key}>{t(c.labelKey)}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </p>
                            <p>
                                <span>{t('mahsulot_olchov')}:</span>
                                <TextField label={t('mahsulot_olchov')} value={unit}
                                           onChange={e => setUnit(e.target.value)}
                                           type="text" variant="outlined"/>
                            </p>
                            <p>
                                <span>{t('product_number')} (miqdor):</span>
                                <TextField label={t('product_number')} value={quantity}
                                           onChange={e => setQuantity(e.target.value)}
                                           type="text" variant="outlined"/>
                            </p>
                            <p>
                                <span>{t('product_price')} (ming so'm):</span>
                                <TextField label={t('product_price')} value={price}
                                           onChange={e => setPrice(e.target.value)}
                                           type="number"
                                           onKeyDown={e => e.key === 'e' && e.preventDefault()}
                                           variant="outlined"/>
                            </p>
                            <p>
                                <span>{t('comment')}:</span>
                                <TextField label={t('comment')} value={description}
                                           onChange={e => setDescription(e.target.value)}
                                           multiline rows={3} variant="outlined"/>
                            </p>
                            <Button type="submit" style={{width: '100%'}} variant="contained" color="info">
                                {t('save')}
                            </Button>
                        </form>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    )
}

export default connect(
    state => state.mahsulot,
    {mahsulotSave, mahsulotEdit, getMahsulotlar, messageReset}
)(MahsulotAdd)
